import PropTypes from 'prop-types';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var classNamePrefix = 'forno-icon-button';
var statuses = ['normal', 'danger'];
var hierarchies = ['primary', 'secondary', 'tertiary'];
var themes = ['light', 'dark'];
var sizesWithLabel = [{
  label: 'extra small',
  value: 'xs'
}, {
  label: 'small',
  value: 's'
}, {
  label: 'medium',
  value: 'm'
}, {
  label: 'large',
  value: 'l'
}];
var sizes = sizesWithLabel.map(function (_ref) {
  var value = _ref.value;
  return value;
});

var _excluded = ["className", "children", "size", "theme", "hierarchy", "disabled", "status"];
var IconButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      size = _ref.size,
      theme = _ref.theme,
      hierarchy = _ref.hierarchy,
      disabled = _ref.disabled,
      status = _ref.status,
      rest = _objectWithoutProperties(_ref, _excluded);

  var customClassName = classNames(classNamePrefix, className);
  return /*#__PURE__*/jsx("button", _objectSpread2(_objectSpread2({
    type: "button",
    ref: ref,
    className: customClassName,
    "data-size": size,
    "data-theme": theme,
    "data-hierarchy": hierarchy,
    "data-disabled": disabled,
    "data-status": status,
    disabled: disabled
  }, rest), {}, {
    children: children
  }));
});
IconButton.displayName = 'IconButton';
IconButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(sizes),
  theme: PropTypes.oneOf(themes),
  hierarchy: PropTypes.oneOf(hierarchies),
  disabled: PropTypes.bool,
  status: PropTypes.oneOf(statuses)
};
IconButton.defaultProps = {
  className: null,
  size: 'm',
  theme: 'light',
  hierarchy: 'primary',
  disabled: false,
  status: 'normal'
};

export { IconButton as default };
